import { useIntl } from 'react-intl';

import Flag from '@atlaskit/flag';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

import { HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './repo-maintenance-flag.i18n';

type Props = {
  id: string;
} & HandleDismissedType;

export const RepoMaintenanceFlag = (props: Props) => {
  const intl = useIntl();
  return (
    <Flag
      appearance="warning"
      title={intl.formatMessage(messages.title)}
      description={intl.formatMessage(messages.description)}
      icon={
        <StatusWarningIcon
          spacing="spacious"
          label=""
          color={token('color.icon.warning')}
        />
      }
      {...props}
    />
  );
};
